import { useState }             from 'react';

export const Checkbox = props => {
    const p                 = props;
    const [ s, setState ]   = useState({
        isChecked: p.checked
    })

    const onClick = (e) => {
        setState(prevState => ({
            isChecked: !prevState.isChecked
        }));


        if (typeof p.onChange === 'function')
            p.onChange(!s.isChecked);
    }

    return (
        <div className="simpra-checkbox">
            <input 
                type            = "checkbox" 
                defaultChecked  = { p.checked } 
                { ...p.attrs}
            />
            <div 
                className       = { `simpra-checkbox-check${p.checked ? ' checked' : ''}` }
                onClick         = { e => onClick(e) }
            />
            {
                p.label
                    ?   <label htmlFor={ p.attrs.name }>{ p.label }</label>  
                    :   null
            }
        </div>        
    )
}

export default Checkbox;